<template>
  <div>
    <v-carousel cycle interval="6000" show-arrows-on-hover :continuous="carrousel.continuous">
          <v-carousel-item  src="../../public/img/aplicaciones_moviles.png" transition="fade-transition" reverse-transition="fade-transition">
          </v-carousel-item>
          <v-carousel-item  src="../../public/img/desarrollo_web.png" transition="fade-transition" reverse-transition="fade-transition">
          </v-carousel-item>
          <v-carousel-item  src="../../public/img/wallaudit_assist.png" transition="fade-transition" reverse-transition="fade-transition">
          </v-carousel-item>
          <v-carousel-item  src="../../public/img/disenio_publicidad.png" transition="fade-transition" reverse-transition="fade-transition">
          </v-carousel-item>
          <v-carousel-item  src="../../public/img/mantenimiento_equipos.png" transition="fade-transition" reverse-transition="fade-transition">
          </v-carousel-item>
          <v-carousel-item  src="../../public/img/soporte_asesorias.png" transition="fade-transition" reverse-transition="fade-transition">
          </v-carousel-item>
          <v-carousel-item  src="../../public/img/telefonia_ip.png" transition="fade-transition" reverse-transition="fade-transition">
          </v-carousel-item>
          <v-carousel-item  src="../../public/img/wallaudit_startup.png" transition="fade-transition" reverse-transition="fade-transition">
          </v-carousel-item>
    </v-carousel>
    <info></info>
    <suscribirse></suscribirse>
    <comunicate></comunicate>
  </div>
</template>

<script>
import info from '@/components/info'
import suscribirse from '@/components/suscribir'
import comunicate from '@/components/contactInfo'
export default {
  data(){
    return{
      carrousel:{
        continuous: true
      },
    }
  },
  components: {
    info,
    suscribirse,
    comunicate
  }
}
</script>

<style>

</style>